import { render, staticRenderFns } from "./DemoPage.vue?vue&type=template&id=73b4161e&"
import script from "./DemoPage.vue?vue&type=script&lang=js&"
export * from "./DemoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports